export default {
  red: '#FF0000',
  orange: '#F87217',
  yellow: '#FFFF00',
  lime: '#00FF00',
  green: '#808000',
  brown: '#800000',
  blue: '#1F45FC',
  pink: '#FF00FF',
  gray: '#98AFC7'
}
